import { Switch } from "@/shared/ui/switch";
import { Label } from "@/shared/ui/label";
import { DatePickerField } from "./DatePickerField";

interface VipFieldProps {
  vip: boolean;
  onVipChange: (checked: boolean) => void;
  vipExpiresAt: Date | null;
  onVipExpiresAtChange: (date: Date | null) => void;
  formErrors: { [key: string]: string };
}

export function VipField({
  vip,
  onVipChange,
  vipExpiresAt,
  onVipExpiresAtChange,
  formErrors,
}: VipFieldProps) {
  return (
    <div className="flex items-start gap-8">
      <div className="w-[320px]">
        <div className="flex items-center justify-between mb-2">
          <Label htmlFor="vip" className="text-white text-base">
            VIP
          </Label>
          <Switch
            id="vip"
            checked={vip}
            onCheckedChange={onVipChange}
            className="data-[state=checked]:bg-[#1677FF]"
          />
        </div>
        <DatePickerField
          label="VIP"
          sublabel="VIP até o dia"
          date={vipExpiresAt}
          onDateChange={onVipExpiresAtChange}
        />
        {formErrors.vipExpiresAt && (
          <p className="text-sm text-red-500">{formErrors.vipExpiresAt}</p>
        )}
      </div>
    </div>
  );
}
